import React from 'react';
import '../../sass/Loading.scss';
import Logo from '../../images/Logo.png';


const Loading = () => {


    return (
        <div className="loading-container">
            <img id="logo" src={Logo} alt="..." />
            <div className="lds-ripple"><div></div><div></div></div>
            <div className="loading-title">
                <h4>CARGANDO...</h4>
            </div>
        </div>
    )
}

export default Loading
